class ProftestPage {
    constructor() {
        this.addListeners()
        this.howToButtons()
    }

    addListeners() {
        const mobile = document.querySelector('.proftest-mobile-listener')
        const galleryList = document.querySelectorAll('.proftest-gallery')

        if (galleryList) {
            galleryList.forEach(gallery => {
                const switchers = gallery.querySelectorAll('.switcher-item')

                switchers.forEach(switcher => {
                    switcher.addEventListener('click', (e) => {
                        this.switchGallery(gallery, switchers, e.target, e.target.dataset.type)
                    })
                })

            })
        }
        
        if (mobile) {
            
            const style = window.getComputedStyle(mobile)
            
            window.addEventListener('resize', () => {
                const mobileNew = document.querySelector('.proftest-mobile-listener')
                const styleNew = window.getComputedStyle(mobileNew)

                if (styleNew.display == 'block') { 
                    this.fixMargin(style.height)
                } else {
                    this.fixMargin(120)
                }
                
            });
            

            if (style.display == 'block') { 
                
                this.fixMargin(style.height)
            }
            
        }
    }

    howToButtons() {
        const webBtn = document.getElementById('howToWeb')
        const mobBtn = document.getElementById('howToMob')

        if (webBtn) {
            webBtn.addEventListener('click', () => {
                this.openHowTo()
            })
        }

        if (mobBtn) {

            mobBtn.addEventListener('click', () => {
                this.openHowTo()
            })

        }
    }

    openHowTo() {
        const modal = document.getElementById('howToModal')
        modal.classList.add('how-to--active')

        const close = modal.querySelector('.close-button')

        close.addEventListener('click', () => {
            modal.classList.remove('how-to--active')
        })

        document.addEventListener('click', (e) => {
            if(e.target.id == 'howToModal') {
                modal.classList.remove('how-to--active')
            }
        })
    }

    switchGallery(gallery, switchers, target, type) {
        const photos = gallery.querySelector('.photos');
        const videos = gallery.querySelector('.videos');
        const reviews = gallery.querySelector('.reviews');
        switchers.forEach(switcher => {
            switcher.classList.remove('switcher-item--checked')
        })



        target.classList.add('switcher-item--checked')

        if (type == 'photos') {
            photos.classList.remove('proftest-gallery--hidden')

            if (videos) {
                videos.classList.add('proftest-gallery--hidden')
            }

            if (reviews) {
                reviews.classList.add('proftest-gallery--hidden')
            }
            
        }

        if (type == 'videos') {

            if (photos) {
                photos.classList.add('proftest-gallery--hidden')
            }
            
            videos.classList.remove('proftest-gallery--hidden')

            if (reviews) {
                reviews.classList.add('proftest-gallery--hidden')
            }
            
        }

        if (type == 'reviews') {

            if (photos) {
                photos.classList.add('proftest-gallery--hidden')
            }
            if (videos) {
                videos.classList.add('proftest-gallery--hidden')
            }

            reviews.classList.remove('proftest-gallery--hidden')
        }
    }

    fixMargin(height) {
        const blocks = document.querySelectorAll('.bgc-block')
        blocks.forEach(block => {
            block.style.paddingTop = parseInt(height) - 120 + 'px';
        })
    }
}

export default ProftestPage